import { makeStyles } from '@material-ui/core';
export const globalStyles = makeStyles((theme) => ({
    confirmDeleteButton: {
        backgroundColor: theme.palette.error.light,
        "&:hover": {
            backgroundColor: theme.palette.error.main,
        }
    },
    cancleDeleteButton: {
        backgroundColor: theme.palette.grey[400],
        "&:hover": {
            backgroundColor: theme.palette.grey[600],
        }
    },
    backgroundColorPrimary: {
        backgroundColor: theme.palette.primary.main,
    },
    backgroundColorPrimaryLight: {
        backgroundColor: theme.palette.info.light,
    },
    backgroundColorErrorDark: {
        backgroundColor: "rgb(140, 39, 45)",
        color:"white",
        "&:hover": {
            backgroundColor: "RGB(83, 0, 0)",
        }
    },
    backgroundColorMiddleGrey: {
        backgroundColor: "RGB(177, 177, 177)",
        "&:hover": {
            backgroundColor: "RGB(124, 124, 124)",
        }
        
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    marginBottomSpacing2: {
        marginBottom: theme.spacing(2),
    },
    showDuoButton: {
        minWidth: "40%",
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(1),
        float: "right"
    },
    showtriButton:{
        minWidth: "20%",
        marginLeft: theme.spacing(1),
        float: "right"
    },
    showButton: {
        minWidth: "82%",
        marginTop: theme.spacing(1),
        float: "right"
    },
    typoH6Style: {
        textAlign: "left",
        //marginLeft: "20px", 
        paddingBottom: "0px",
    },
    tableHeadline: {
        //backgroundColor: theme.palette.info.light,
        color: theme.palette.primary.main,
        alignSelf: "center",
        height: "-webkit-fill-available",
        //padding: "10px"
    },
    tableHeadlineSub:{
        color: theme.palette.primary.main,
    },

    tableHeadlineGrey: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        alignSelf: "center",
        height: "-webkit-fill-available", 
        paddingTop: "10px"
    },
    tableHeadlineAutocomplete: {
        backgroundColor: theme.palette.info.light,
        color: "white",
        alignSelf: "center",
        paddingTop: "10px"
    },
    addIconRight:{
        color: "white",
        alignSelf: "end",
    },
    paddingPaper:{
        paddingBottom: theme.spacing(2),
        minHeight:"100%",
        height:"100%"
    },
    heightPaper:{
        minHeight:"100%",
        height:"100%"
    },
    heightScrolledTableTop:{
        maxHeight: "680px",
    },
    heightScrolledTableTopExpanded:{
        maxHeight: "550px",
    },
    heightScrolledTableBottom:{
        maxHeight: "500px",
    },
    HeadlineStyle: {
        backgroundColor: theme.palette.info.light,
        minHeight: "100px"
    },
    autocompleteSelect: {
        paddingLeft: "10px",
        paddingRight: "10px",

    },
    centerTypographyRoot: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    autocompleteStyle: {
        textAlignLast: "left",
        display: "block",
        color: "white !important",
        label: { color: "white !important" },
        "&:before": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:hover": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:after": {
            color: "white !important",
            borderColor: "white !important",
        },
        "&:active": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:focus": {
            color: "white !important",
            borderColor: "white !important"
        },
        "&:target": {
            color: "white !important",
            borderColor: "white !important"
        },
        "& .MuiIconButton-label": {
            color: "white !important",
            borderColor: "white !important"
        },
    },
    redSignalColor:{
        color: theme.palette.error.main,
    },
    fullWidth:{
        width:"100% !important",
        fullWidth: true,
        "& .MuiFormControl-root":{
            width:"100% !important",
            fullWidth: true,
        }
    },
    sectionLabelControl: {
        minWidth: "100%",
        marginTop: "20px",
        marginBottom: "20px",
        fontSize: "16px",
        color: "#000000"
    },
    menuItemSelected: {
        backgroundColor: "RGB(225, 225, 225)",
        "&:hover": {
            backgroundColor: "RGB(200, 200, 200)"
        },
    },
    textFieldRoot: {
        "& > div.MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root']": {
          // default paddingRight was 39px since clear icon was positioned absolute
          paddingRight: "9px",
          fontSize: "0.9rem",
    
          // Search icon
          "& button": {
            order: 3, // order 3 means the search icon will appear after the clear icon which has an order of 2
            fontSize: "0.9rem"
          },
          // Clear icon
          "& > div.MuiAutocomplete-endAdornment": {
            position: "relative", // default was absolute. we make it relative so that it is now within the flow of the other two elements
            order: 2,
          },
        },
    },
}), {index: 1});